'use strict';
import $ from 'jquery';

export default class BlogGridSubscribeForm {
    static init() {
        $('.single-blog-main-sidebar-subscribe').each((index, el) => {
            new BlogGridSubscribeForm($(el));
        });
    }

    constructor($el) {
        this.el = $el;
        this.el.find('form').on('submitSuccess', (e) => {
            this.el.find('form').hide();
            this.el.find('h4').hide();
            this.el.find('.thank-you').show();
        });
    }
}